module.exports = __webpack_public_path__ + "static/media/icon_interactions_off.72b1fe8f.png";